@let notificationCountUnread = notificationCountUnread$ | async;

<div class="wrapper">
  @if (
    userRoles.includes(roleName.Buyer) || userRoles.includes(roleName.Admin)
  ) {
    <button
      mat-button
      class="header__create-button"
      [matMenuTriggerFor]="createMenu">
      <img src="assets/svg/plusWhite.svg" alt="plus" />{{
        'CREATE' | translate
      }}
    </button>
  }

  <div class="wrapper-messengers">
    <div class="wrapper-btn">
      <img class="header-iconBtn" src="assets/svg/ai.svg" alt="Ai" />
      <p>AI Helper</p>
    </div>
    <div class="wrapper-btn">
      <img
        class="header-iconBtn"
        src="assets/svg/messages.svg"
        alt="Messages" />
      <p>Chats</p>
    </div>
    <button
      class="wrapper-btn notification"
      (click)="headerComponent.openNotificationPanel(); closeSideBarMenu.emit()"
      [ngClass]="{ active: headerComponent.isOpenNotificationPanel }">
      <img class="header-iconBtn" src="assets/svg/bell.svg" alt="Bell" />
      @if (notificationCountUnread) {
        <p class="notification_count"></p>
      }
      <p>Notifications</p>
    </button>
  </div>
  <div class="headerBlock">
    @if (userInfo.company?.companyStatus === companyStatus.Blocked) {
      <span class="headerBlock-blocked"
        >{{ 'PROFILE_IS_BLOCKED' | translate }}.
        <i class="headerBlock-blocked--clickable" (click)="goToProfile()">{{
          'DETAILS' | translate
        }}</i></span
      >
    }
    <div class="nameBlock">
      <img
        class="profilePic"
        [src]="userInfo.logoUrl ?? 'assets/svg/user-plug.svg'"
        width="40"
        height="40"
        alt="" />
      <div class="infoBox">
        <h4 class="name">
          {{ userInfo.firstName + ' ' + userInfo.lastName }}
        </h4>
        <p class="companyName">{{ userInfo?.company?.name }}</p>
      </div>
    </div>
  </div>
  <div class="buttonsList">
    <button class="item">
      <img src="assets/svg/role.svg" width="24" height="24" alt="Role" />
      <p class="itemName">{{ 'YOUR_ROLE' | translate }}: {{ roles }}</p>
    </button>
    <button class="item">
      <img
        src="assets/svg/viewProfile.svg"
        width="24"
        height="24"
        alt="Profile" />
      <p class="itemName">{{ 'VIEW_PROFILE' | translate }}</p>
    </button>
    <button class="item" (click)="navigationToPage('/company/details')">
      <img
        src="assets/svg/settings.svg"
        width="24"
        height="24"
        alt="Settings" />
      <p class="itemName">{{ 'ORGANIZATION_SETTINGS' | translate }}</p>
    </button>
    <div class="button">
      <button class="item" [matMenuTriggerFor]="langMenu">
        <img
          src="assets/svg/language.svg"
          width="24"
          height="24"
          alt="Language" />
        <p class="itemName">{{ 'LANGUAGE' | translate }}</p>
        <span class="langBox">
          {{ currentLang | uppercase }}
        </span>
      </button>
      <mat-menu #langMenu class="langMenu">
        @for (language of languagesLists; track $index) {
          @if (language.isView) {
            <button
              [ngClass]="{
                'active-language': language.uniCode === currentLang
              }"
              mat-menu-item
              (click)="selectCurrentLanguage(language.uniCode)">
              {{ language.title }}
            </button>
          }
        }
      </mat-menu>
    </div>
    <button class="item">
      <img src="assets/svg/help.svg" width="24" height="24" alt="Help" />
      <p class="itemName">{{ 'HELP_CENTER' | translate }}</p>
    </button>
  </div>
  @if (
    !userRoles.includes(roleName.Supplier) || userRoles.includes(roleName.Admin)
  ) {
    <div class="freeTrial">
      <div class="trialNames">
        <p class="title">{{ 'FREE_TRIAL' | translate }}</p>
        <p class="daysLeft">{{ '30_DAYS_LEFT' | translate }}</p>
      </div>
      <button mat-raised-button class="btn-primary">
        {{ 'UPGRADE' | translate }}
      </button>
    </div>
  }

  <div class="logout">
    <button (click)="logout()" class="logoutBtn">
      <img src="assets/svg/logout.svg" width="24" height="24" alt="Logout" />{{
        'LOGOUT' | translate
      }}
    </button>
  </div>
</div>

<div class="overlay" (click)="closePopup()"></div>

<mat-menu #createMenu>
  @for (item of dropdownItems; track item.type) {
    @if (!item.requiredRole || userRoles.includes(item.requiredRole)) {
      <div (click)="selectItem(item.type)" mat-menu-item>
        <div class="create-menu-item">
          <img [src]="'assets/svg/' + item.icon" [alt]="item.type" />
          <span>{{ item.type | uppercase | translate }}</span>
        </div>
      </div>
    }
  }
</mat-menu>
